import { User } from "oidc-client-ts";
import { GetTokenManually } from "./WebPortalTokenClient";

function timer(ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
}

export async function fetchRetry(url: RequestInfo, options: RequestInit, retries: number, delay: number): Promise<Response> {

    for (; retries > 0; retries--) {

        const response = await fetch(url, options);

        if (response.ok)
            return response;

        await timer(delay);
    }
}

export async function authenticatedFetchRetry(authUser: User, url: RequestInfo, init: RequestInit, retries: number, delay: number): Promise<Response> {
    for (; retries > 0; retries--) {

        const authInit = authUser?.access_token
            ? {
                ...init,
                credentials: 'same-origin',
                headers: { ...init?.headers, 'Authorization': `Bearer ${GetTokenManually()?.access_token ?? authUser?.access_token}` },
            } as RequestInit
            : init;

        const response = await fetch(url, authInit);

        if (response.ok)
            return response;

        await timer(delay);
    }

    return Promise.reject();
}
